// src/components/timeBoxes/TaskSelector/TaskListItem.tsx
// 任務選擇器中的單個任務項目

import React from 'react';
import { Task, categoryColors, categoryLabels } from '../../../../types/task';
import { CheckCircle, Circle } from '../../../../components/common/icons';

interface TaskListItemProps {
  task: Task;
  onClick: () => void;
  isSelected?: boolean;
}

/**
 * 任務列表項目
 *
 * 顯示：
 * - 狀態圖示（OPEN/CLOSED）
 * - 任務標題
 * - 分類標籤
 * - 選中狀態高亮（藍色背景 + 左側邊框）
 */
export const TaskListItem: React.FC<TaskListItemProps> = ({ task, onClick, isSelected = false }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-4 py-3 transition-colors text-left border-b border-gray-100 last:border-b-0 ${
        isSelected
          ? 'bg-sky-50 border-l-2 border-l-sky-500 pl-[14px]'
          : 'hover:bg-gray-50 active:bg-gray-100'
      }`}
      aria-selected={isSelected}
    >
      {/* 狀態圖示 */}
      <div className={`shrink-0 ${task.status === 'CLOSED' ? 'text-green-500' : 'text-gray-400'}`}>
        {task.status === 'CLOSED' ? (
          <CheckCircle size={18} />
        ) : (
          <Circle size={18} />
        )}
      </div>

      {/* 任務資訊 */}
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-medium text-gray-800 truncate ${task.status === 'CLOSED' ? 'line-through text-gray-500' : ''}`}>
          {task.title}
        </p>
        {task.category && (
          <span className={`inline-block px-2 py-0.5 text-xs rounded-full mt-1 ${categoryColors[task.category]}`}>
            {categoryLabels[task.category]}
          </span>
        )}
      </div>
    </button>
  );
};
